import React from 'react';
import PropTypes from 'prop-types';

import iconFlip from '../../assets/images/image_flip.png';
import { isFase1Ativa } from '../../utils/fase';
import { getImagem } from '../../utils/imagens';

const Categorias = ({ categorias, onCategoriaClick, cidade }) => {
  const fase1Ativa = isFase1Ativa(cidade);

  return (
    <div
      className={`in-step-ctn-grid-ctt-cards ${
        !fase1Ativa ? 'in-step-ctn-grid-ctt-cards--sem-botao' : ''
      }`}
    >
      <ul>
        {categorias.map((cat) => {
          const imagemSrc = getImagem(cat.imagem);

          return (
            <li key={cat.slug}>
              <div
                onClick={() =>
                  onCategoriaClick && onCategoriaClick(cat.slug, fase1Ativa)
                }
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && onCategoriaClick) {
                    onCategoriaClick(cat.slug, fase1Ativa);
                  }
                }}
              >
                <div
                  className={`in-step-ctn-grid-ctt-cards-flip ${
                    !fase1Ativa
                      ? 'in-step-ctn-grid-ctt-cards-flip--sem-botao'
                      : ''
                  }`}
                >
                  <div className="in-step-ctn-grid-ctt-cards-flip-front">
                    {imagemSrc && <img src={imagemSrc} alt={cat.nome} />}
                    <div>
                      <p>{cat.nome}</p>
                      {fase1Ativa && <button type="button">Vote Agora!</button>}
                    </div>
                  </div>
                  <div className="in-step-ctn-grid-ctt-cards-flip-back">
                    <img src={iconFlip} alt="" />
                    <div>
                      <p>{cat.nome}</p>
                      <p>{cat.descricao}</p>
                      {fase1Ativa && <button type="button">Vote Agora!</button>}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

Categorias.propTypes = {
  categorias: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string.isRequired,
      nome: PropTypes.string.isRequired,
      imagem: PropTypes.string.isRequired,
      descricao: PropTypes.string
    })
  ).isRequired,
  onCategoriaClick: PropTypes.func,
  cidade: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

Categorias.defaultProps = {
  onCategoriaClick: null,
  cidade: null
};

export default Categorias;
